import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import type { LiveMsgOrJoinShowTipProps } from './components/SellerIsHostingShowTipPageContent';

const SellerIsHostingShowTipPageContent = lazy(
  () => import('./components/SellerIsHostingShowTipPageContent'),
);

export const SellerIsHostingShowTipPage = wrapLazyNavigatorScreen(
  (props: LiveMsgOrJoinShowTipProps) => {
    return <SellerIsHostingShowTipPageContent {...props} />;
  },
  {
    headerShown: false,
  },
);
